import $ from 'jquery';

$(document).on("click", '.study-program__programs-button-first,.study-program__programs-button', function(event) {
    event.preventDefault();
});

$(document).on("mousedown", '.study-program__programs-button-first,.study-program__programs-button', function(event) {
    var decodeUrl = $(this).attr('href');
    const url = new URL(window.location);
    if (url.searchParams.has('rup')) {
        var encodeUrl = url.searchParams.get('rup');
        decodeUrl = atob(encodeUrl);
    }
    switch (event.which) {
        case 1:
            window.location.href = decodeUrl;
            break;
        case 2:
            window.open(decodeUrl);
            break;
        case 3:
            var $this = $(this);
            $this.attr('href', decodeUrl);
            break;
        default:
    }
});

$(document).ready(changeCountSubject);
$(window).on('resize', changeCountSubject);

function changeCountSubject() {
    var documentWidth = $(this).width();
    
    $('.accordion-subject').each(function() {
        var firstColumnLi = $(this).find('.study-program__required li');
        var secondColumnLi = $(this).find('.study-program__elective-optional li');

        var showButton = false;
        if (documentWidth > 991) {
            var i = 0;
            firstColumnLi.each(function() {
                i++;
                $(this).css('display', 'block');
                if (i > 15) {
                    $(this).css('display', 'none');
                    showButton = true;
                }
            });
            var i = 0;
            secondColumnLi.each(function() {
                i++;
                $(this).css('display', 'block');
                if (i > 15) {
                    $(this).css('display', 'none');
                    showButton = true;
                }
            });
        } else {
            var i = 0;
            firstColumnLi.each(function() {
                i++;
                $(this).css('display', 'block');
                if (i > 15) {
                    $(this).css('display', 'none');
                    showButton = true;
                }
            });
            secondColumnLi.each(function() {
                i++;
                $(this).css('display', 'block');
                if (i > 15) {
                    $(this).css('display', 'none');
                    showButton = true;
                }
            });
        }

        if (showButton) {
            $(this).find('.showMore').css('display', 'flex');
        }
    });
}

$(document).on("click", '.study-program__subject-accordion .showMore__item', function(event) {
    var $this = $(this);
    var accordion = $this.parent().parent();
    var firstColumnLi = accordion.find('.study-program__required li');
    var secondColumnLi = accordion.find('.study-program__elective-optional li');

    firstColumnLi.each(function() {
        $(this).css('display', 'block');
    });
    secondColumnLi.each(function() {
        $(this).css('display', 'block');
    });
    $this.parent().css('display', 'none');
});

document.addEventListener("DOMContentLoaded", function() {
    const ulElements = document.querySelectorAll('.study-program__subject-specialization-text');

    ulElements.forEach(ul => {
        const itemCount = ul.children.length;
        ul.classList.add(`items-${itemCount}`);
    });
});